module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="form-group">\n    <label for="' +
__e( fieldState.getInternal() ) +
'-' +
__e( fieldState.getId() ) +
'">' +
__e( fieldState.getLabel() ) +
'</label>\n    <div class="input-group phone" data-id="' +
__e( fieldState.getId() ) +
' ">\n        <input type="tel" class="form-control phoneInput changeableField" id="' +
__e( fieldState.getInternal() ) +
'-' +
__e( fieldState.getId() ) +
'" value="' +
__e( fieldState.getValue() ) +
'" ' +
__e( fieldState.isEnabled() ? '' : 'disabled') +
'  ' +
__e( fieldState.isReadOnly() ? 'readonly' : '') +
' ><a href="" class="input-group-addon" aria-label="Appeler"><span class="glyphicon-earphone glyphicon"></span></a>\n    </div>\n</div>\n';

}
return __p
}